import React from "react";
import Header from "./Header";
import UploadFile from "./UploadFile";

const ImportCatalog = () => {
  return (
    <div>
      {/* Header */}
      <Header />
      {/* Body  */}
      <div className="mt-[50px] w-[100%] flex items-center justify-center">
        <UploadFile />
      </div>
    </div>
  );
};

export default ImportCatalog;
